(function () {
  var INPUT_SELECTORS = 'input, textarea, select';

  function lang() {
    return (document.documentElement.lang || 'es').toLowerCase();
  }

  function localeKey() {
    var l = lang();
    if (l.indexOf('en') === 0) return 'en';
    if (l.indexOf('fr') === 0) return 'fr';
    if (l.indexOf('de') === 0) return 'de';
    if (l.indexOf('pt') === 0) return 'pt';
    return 'es';
  }

  var COPY = {
    es: {
      submit: 'Recibir mi descuento',
      vip: '10% de descuento',
      thanks: '¡Gracias por suscribirse!',
      checkDevice: 'Revise su correo para recibir su código del 10%.',
      firstName: 'Su nombre',
      lastName: 'Su apellido',
      email: 'Su correo electrónico',
      phone: 'Su teléfono',
      headline: 'Suscríbase y reciba su código exclusivo',
      firstOrder: '10% en su primera compra'
    },
    pt: {
      submit: 'Receber o meu desconto',
      vip: '10% de desconto',
      thanks: 'Obrigada por subscrever!',
      checkDevice: 'Verifica o teu email para receber o teu código de 10%.',
      firstName: 'O teu nome',
      lastName: 'O teu apelido',
      email: 'O teu email',
      phone: 'O teu telefone',
      headline: 'Subscreve e recebe o teu código exclusivo',
      firstOrder: '10% na tua primeira compra'
    },
    en: {
      submit: 'Get my discount',
      vip: '10% off',
      thanks: 'Thanks for subscribing!',
      checkDevice: 'Check your email for your 10% code.',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone number',
      headline: 'Subscribe and get your exclusive code',
      firstOrder: '10% off your first order'
    },
    fr: {
      submit: 'Recevoir ma réduction',
      vip: '10 % de réduction',
      thanks: 'Merci de votre inscription !',
      checkDevice: 'Consultez votre e-mail pour recevoir votre code de 10 %.',
      firstName: 'Prénom',
      lastName: 'Nom',
      email: 'E-mail',
      phone: 'Téléphone',
      headline: 'Inscrivez-vous et recevez votre code exclusif',
      firstOrder: '10 % sur votre première commande'
    },
    de: {
      submit: 'Meinen Rabatt erhalten',
      vip: '10 % Rabatt',
      thanks: 'Danke fürs Abonnieren!',
      checkDevice: 'Prüfe deine E-Mail für deinen 10 %-Code.',
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phone: 'Telefon',
      headline: 'Abonnieren und exklusiven Code erhalten',
      firstOrder: '10 % auf deine erste Bestellung'
    }
  };

  function strings() {
    return COPY[localeKey()] || COPY.es;
  }

  function textReplacements() {
    var s = strings();
    return [
      [/^\s*SUBMIT\s*$/i, s.submit],
      [/^\s*Submit\s*$/i, s.submit],
      [/^\s*Recibir mi descuento\s*$/i, s.submit],
      [/^\s*Get my discount\s*$/i, s.submit],
      [/^\s*Recevoir ma réduction\s*$/i, s.submit],
      [/^\s*Meinen Rabatt erhalten\s*$/i, s.submit],
      [/^\s*Join VIP!?\s*$/i, s.vip],
      [/^\s*10%\s*de descuento\s*$/i, s.vip],
      [/^\s*10%\s*off\s*$/i, s.vip],
      [/^\s*10\s*%\s*de réduction\s*$/i, s.vip],
      [/^\s*10\s*%\s*Rabatt\s*$/i, s.vip],
      [/15%\s*en su primera compra/i, s.firstOrder],
      [/10%\s*en su primera compra/i, s.firstOrder],
      [/15%\s*de descuento/i, s.vip],
      [/código del 15%/i, 'código del 10%'],
      [/^\s*YOU'?RE IN!?\s*$/i, s.thanks],
      [/^\s*Check your device.*$/i, s.checkDevice],
      [/^\s*Welcome!?\s*$/i, s.thanks],
      [/^\s*First [Nn]ame\s*$/i, s.firstName],
      [/^\s*Last [Nn]ame\s*$/i, s.lastName],
      [/^\s*Email\s*$/i, s.email],
      [/^\s*E-mail\s*$/i, s.email],
      [/^\s*Su correo electrónico\s*$/i, s.email],
      [/^\s*Su nombre\s*$/i, s.firstName],
      [/^\s*Su apellido\s*$/i, s.lastName],
      [/Suscr[ií]base y reciba su c[oó]digo exclusivo/i, s.headline],
      [/Subscribe and get your exclusive code/i, s.headline],
      [/Inscrivez-vous et recevez votre code exclusif/i, s.headline],
      [/Abonnieren und exklusiven Code erhalten/i, s.headline]
    ];
  }

  function placeholderMap() {
    var s = strings();
    return {
      Email: s.email,
      'E-mail': s.email,
      'First Name': s.firstName,
      'Last name': s.lastName,
      'Last Name': s.lastName,
      'Phone Number': s.phone,
      'Su correo electrónico': s.email,
      'Su nombre': s.firstName,
      'Su apellido': s.lastName,
      'Su teléfono': s.phone
    };
  }

  function isKlaviyoRoot(node) {
    if (!node || node.nodeType !== 1) return false;
    var cls = (node.className && node.className.toString ? node.className.toString() : '').toLowerCase();
    return /klaviyo|kl-private|needsclick/.test(cls) || node.closest('[class*="klaviyo"], [class*="kl-private"], .needsclick');
  }

  function applyInputStyles(root) {
    var placeholders = placeholderMap();
    root.querySelectorAll(INPUT_SELECTORS).forEach(function (input) {
      if (input.type === 'hidden' || input.type === 'checkbox' || input.type === 'radio') return;
      input.style.setProperty('color', '#000000', 'important');
      input.style.setProperty('-webkit-text-fill-color', '#000000', 'important');
      input.style.setProperty('background-color', '#FFFFFF', 'important');
      input.style.setProperty('caret-color', '#000000', 'important');

      if (placeholders[input.placeholder]) {
        input.placeholder = placeholders[input.placeholder];
      }
    });
  }

  function applyReplacementsToText(text) {
    var next = text;
    textReplacements().forEach(function (pair) {
      if (pair[0].test(next)) {
        next = next.replace(pair[0], pair[1]);
      }
      pair[0].lastIndex = 0;
    });
    return next;
  }

  function replaceVisibleText(root) {
    root.querySelectorAll('button, label, p, span, h1, h2, h3, h4, div').forEach(function (el) {
      if (el.children.length > 0) return;
      var text = (el.textContent || '').trim();
      if (!text) return;
      var next = applyReplacementsToText(text);
      if (next !== text) el.textContent = next;
    });

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var value = node.nodeValue || '';
      if (!/15%|10%|Join VIP|SUBMIT|Submit|YOU'?RE IN|Welcome|First Name|Last Name|Email|E-mail|Su correo|Su nombre|Su apellido|descuento|Suscr|Subscribe and get|Inscrivez|Abonnieren|Recibir mi|Get my discount|Recevoir ma|Meinen Rabatt|primera compra|first order|première commande|erste Bestellung/i.test(value)) continue;
      var replaced = applyReplacementsToText(value);
      if (replaced !== value) node.nodeValue = replaced;
    }
  }

  function walkTree(root, fn) {
    if (!root) return;
    fn(root);
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) walkTree(el.shadowRoot, fn);
    });
  }

  function fixKlaviyoPopup() {
    walkTree(document, function (root) {
      if (root === document || isKlaviyoRoot(root) || root.host) {
        applyInputStyles(root);
        replaceVisibleText(root);
      }
    });
  }

  fixKlaviyoPopup();

  var observer = new MutationObserver(function () {
    fixKlaviyoPopup();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setInterval(fixKlaviyoPopup, 800);
})();
